module.exports = __webpack_public_path__ + "img/menuIcon2.2f3dd197.png";